module.exports = "<mat-sidenav-container>\r\n  <router-outlet></router-outlet>\r\n</mat-sidenav-container>"